// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"g5-z","dimensionLabel":"h5-z","styleChooserControlWrapper":"i5-z","styleChooserControl":"j5-z","disabled":"k5-z","giftCard":"l5-z","styleChooserText":"m5-z"};